<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title">Dataset Size</p>
        </header>
        <div class="card-content">
            <div class="table-container">
                <table class="table is-fullwidth">
                    <thead>
                        <th style="min-width: 10em;">Experiment</th>
                        <th>x</th>
                        <th>y</th>
                        <th>z</th>
                    </thead>
                    <tbody>
                        <!-- Use the computed property (visibleFrames) for v-for -->
                        <template v-for="cf in visibleFrames">
                            <tr class="is-borderless">
                                <td
                                    colspan="4"
                                    style="
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                    "
                                >
                                    <a :href="cf.link" target="_blank">
                                        {{ cf.experimentName }}
                                    </a>
                                </td>
                            </tr>
                            <tr class="is-borderless">
                                <td class="pl-15px"><small>Dataset</small></td>
                                <td v-for="unit in ['x', 'y', 'z']" :key="unit">
                                    <small>
                                        <b>
                                            {{
                                                readableLength(
                                                    cf[`${unit}_distance`],
                                                    fullUnit(cf.voxel_unit)
                                                )
                                            }}
                                        </b>
                                        <br />
                                        ({{ cf[`${unit}_length`] }}
                                        at
                                        {{ cf[`${unit}_voxel_size`] }}
                                        {{ cf.voxel_unit }})
                                    </small>
                                </td>
                            </tr>
                            <tr>
                                <td class="pl-15px">
                                    <small>Coordinate Frame</small>
                                </td>
                                <td v-for="unit in ['x', 'y', 'z']" :key="unit">
                                    <small>
                                        [{{ cf[`${unit}_start`] }},
                                        {{ cf[`${unit}_stop`] }}]
                                    </small>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>

            <!-- Show more / Show less link -->
            <div v-if="coordinateFramesData.length > 5" class="has-text-right">
                <a href="#" @click.prevent="toggleShowAll">
                    {{ showAll ? "Show less" : "Show more" }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CoordinateFrameCard",
    props: {
        coordinateFrames: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            // Controls whether all experiments are shown
            showAll: false,
        };
    },

    computed: {
        coordinateFramesData() {
            return this.coordinateFrames.map(cf => {
                return {
                    x_length: cf.x_stop - cf.x_start,
                    x_distance: (cf.x_stop - cf.x_start) * cf.x_voxel_size,
                    y_length: cf.y_stop - cf.y_start,
                    y_distance: (cf.y_stop - cf.y_start) * cf.y_voxel_size,
                    z_length: cf.z_stop - cf.z_start,
                    z_distance: (cf.z_stop - cf.z_start) * cf.z_voxel_size,
                    ...cf
                };
            });
        },
        // Show the entire list if showAll is true; otherwise show just the first five
        visibleFrames() {
            if (this.showAll) {
                return this.coordinateFramesData;
            }
            return this.coordinateFramesData.slice(0, 5);
        },
    },

    methods: {
        toggleShowAll() {
            this.showAll = !this.showAll;
        },
        fullUnit(unit) {
            return {
                "nm": "nanometers",
                // "μm": "microns",
                "\u00b5m":  "micrometers",
                "µm": "micrometers",
                "mm": "millimeters",
                "cm": "centimeters",
                "m": "meters",
                "km": "kilometers",
            }[unit];
        },
        readableLength(distance, baseUnits) {
            if (distance >= 800000 && baseUnits === "nanometers") {
                return `${Number((distance / (1000 * 1000)).toFixed(2))} mm`;
            }
            if (distance >= 8000 && baseUnits === "nanometers") {
                return `${Number((distance / 1000).toFixed(2))} μm`;
            }
            if (distance >= 1000 && baseUnits === "micrometers") {
                return `${Number((distance / 1000).toFixed(2))} mm`;
            }
            return `${distance} ${baseUnits}`;
        },
    },
};
</script>

<style lang="scss">
.is-borderless td {
    border: 0;
}

.pl-15px small {
    padding-left: 15px;
}
</style>
